import Autosuggest from "react-autosuggest";
import React, { useState } from "react";
import { getProducts } from "../../helper";
import ProductRow from "../ProductRow/index";
import "./styles.scss";

export default function HomeSearch(props) {
  const { cart, addToCart, isMobile, backend } = props;
  const [suggestions, setSuggestions] = useState([]);
  const [searchString, setSearchString] = useState(null);

  const onChange = (event, { newValue, method }) => setSearchString(newValue);

  const getSuggestionValue = () => searchString;

  const renderSuggestion = (suggestion) => (
    <ProductRow
      backend={backend}
      key={suggestion.product_id}
      product={suggestion}
      addToCart={addToCart}
      cart={cart}
      search={true}
      isMobile={isMobile}
    />
  );

  const onSuggestionsFetchRequested = async ({ value }) =>
    searchString !== value &&
    (await getProducts({
      searchString: value,
      perPage: 10,
      pageNo: 1,
    }).then((result) => setSuggestions(result.products)));

  const onSuggestionsClearRequested = () => setSuggestions([]);

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={{
        placeholder: "Search Products",
        value: searchString || "",
        onChange: onChange,
        type: "search",
      }}
      focusInputOnSuggestionClick={true}
      alwaysRenderSuggestions={true}
    />
  );
}
